/**
 * 화면 전환 애니메이션 (Fade-in)
 */
window.addEventListener('load', function () {
  document.body.classList.add('is-loaded');
});

// 만약 자바스크립트 오류 등으로 화면이 계속 안 보일 경우를 대비한 안전장치 (3초 후 강제 노출)
setTimeout(function () {
  if (!document.body.classList.contains('is-loaded')) {
    document.body.classList.add('is-loaded');
  }
}, 3000);
